// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3eUdK","boxTitle":"Qualiphy_boxTitle__2Ss-n","box":"Qualiphy_box__3rpXa","toggleWrap":"Qualiphy_toggleWrap__1-Nnm"};